"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expand = void 0;
exports.expand = {
    path: "M2.5 7.5V4.16667C2.5 3.25 3.25 2.5 4.16667 2.5H7.5V4.16667H4.16667V7.5H2.5ZM2.5 12.5H4.16667V15.8333H7.5V17.5H4.16667C3.25 17.5 2.5 16.75 2.5 15.8333V12.5ZM15.8333 15.8333H12.5V17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V12.5H15.8333V15.8333ZM12.5 2.5H15.8333C16.75 2.5 17.5 3.25 17.5 4.16667V7.5H15.8333V4.16667H12.5V2.5Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
